import React, { Suspense, useState } from 'react';
import { LocaleProvider, Loading } from '@op/opds.opux';
import './App.scss';
import { MessageProvider } from '@messageformat/react';
import messages from './messages/msgData';
import { getLocale } from './util/commonUtil';
import BecomeCustomer from './components/Become_customer/BecomeCustomer';
import CardSelectorTool from './components/Service_plan_selector/CardSelectorTool';
import ErrorBoundary from './ErrorBoundary';

const localizedPaths = {
  becomeCustomerPaths: ['tule-opn-asiakkaaksi', 'bli-kund-hos-op', 'become-op-customer'],
  cardGuidePaths: ['korttiapuri', 'kortguide', 'card-guide'],
};

enum View {
  BecomeCustomer,
  CardGuide,
}

const resolveView = (): View => {
  const currentPath = window.location.pathname.split('/').pop();
  if (currentPath && localizedPaths.becomeCustomerPaths.includes(currentPath)) {
    return View.BecomeCustomer;
  } else {
    return View.CardGuide;
  }
};

function App() {
  const locale = getLocale();
  const [view] = useState<View>(resolveView);

  return (
    <MessageProvider messages={messages[locale]}>
      <LocaleProvider locale={locale}>
        <div className="opux-v6__opds App">
          <ErrorBoundary>
            <Suspense
              fallback={
                <div style={{ textAlign: 'center' }}>
                  <Loading />
                </div>
              }
            >
              {view === View.BecomeCustomer && <BecomeCustomer />}
              {view === View.CardGuide && <CardSelectorTool />}
            </Suspense>
          </ErrorBoundary>
        </div>
      </LocaleProvider>
    </MessageProvider>
  );
}

export default App;
